import React  from 'react';
//import PropTypes from 'prop-types';

const Input2 = ({  name, label, error, ...rest  }) => {
    let label_var = label;
    if(label === "http://yourdomain.com")
    {
        label_var = ""
    }
        return (
            <div>
                <label>{label_var}</label>
                <input name={name} placeholder={label} {...rest}/>
                {error && <div className="alert alert-danger" style={{padding: 0, color: "#EF4848"}}>
                  <strong>{error} </strong>
                </div>}
            </div>

        );
};


//Input.propTypes = {
//    name: PropTypes.number.isRequired,
//    pageSize: PropTypes.number.isRequired,
//    currentPage: PropTypes.number.isRequired,
//    onPageChange: PropTypes.func.isRequired
//};

export default Input2;
